var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 11,
    viewBox: "0 0 27 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66406 0.644531C1.52441 0.644531 0 2.10742 0 4.11035V4.12402C0 5.99707 1.32617 7.37793 3.21973 7.37793C4.57324 7.37793 5.43457 6.6875 5.79687 5.9082H5.93359C5.93359 5.9834 5.92676 6.05859 5.92676 6.13379C5.85156 8.02051 5.18848 9.55176 3.62305 9.55176C2.75488 9.55176 2.14648 9.10058 1.88672 8.41016L1.86621 8.3418H0.129883L0.143555 8.41699C0.458008 9.92773 1.81152 11.001 3.62305 11.001C6.10449 11.001 7.60156 9.03223 7.60156 5.70996V5.69629C7.60156 2.1416 5.76953 0.644531 3.66406 0.644531ZM3.65723 6.02441C2.53613 6.02441 1.72266 5.2041 1.72266 4.0625V4.04883C1.72266 2.94824 2.59082 2.08008 3.67773 2.08008C4.77148 2.08008 5.62598 2.96191 5.62598 4.08984V4.10352C5.62598 5.21777 4.77148 6.02441 3.65723 6.02441Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4251 4.36328C11.054 4.36328 11.512 3.88477 11.512 3.2832C11.512 2.6748 11.054 2.20312 10.4251 2.20312C9.80301 2.20312 9.33816 2.6748 9.33816 3.2832C9.33816 3.88477 9.80301 4.36328 10.4251 4.36328ZM10.4251 9.43555C11.054 9.43555 11.512 8.96387 11.512 8.35547C11.512 7.74707 11.054 7.27539 10.4251 7.27539C9.80301 7.27539 9.33816 7.74707 9.33816 8.35547C9.33816 8.96387 9.80301 9.43555 10.4251 9.43555Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0337 10.7549H19.7222V8.86133H21.0484V7.40527H19.7222V0.890625H17.2271C15.8873 2.92773 14.4859 5.19727 13.2076 7.41894V8.86133H18.0337V10.7549ZM14.8482 7.44629V7.34375C15.8052 5.66894 16.9468 3.84375 17.9586 2.29883H18.0611V7.44629H14.8482Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8563 10.7549H26.62V0.890625H24.8631L22.286 2.70215V4.36328L24.7401 2.62695H24.8563V10.7549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime0);
export default __webpack_public_path__ + "static/media/time0.6fc913f4eb9d8411d79b24465647e386.svg";
export { ForwardRef as ReactComponent };